import { render, staticRenderFns } from "./invoiceApplyDetailFee.vue?vue&type=template&id=70a57e28&scoped=true"
import script from "./invoiceApplyDetailFee.vue?vue&type=script&lang=js"
export * from "./invoiceApplyDetailFee.vue?vue&type=script&lang=js"
import style0 from "./invoiceApplyDetailFee.vue?vue&type=style&index=0&id=70a57e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a57e28",
  null
  
)

export default component.exports